









































import { Component, Vue } from 'vue-property-decorator'
import api, { NotAuthenticated } from '@/services/api'

import GifGrid from './GifGrid.vue'

@Component({
    components: {
        GifGrid,
    },
    watch: {
        $route(to, from) {
            ;(this as any).updateSelectedCategory()
        },
    },
    beforeRouteLeave(to, from, next) {
        ;(this as any).hide = true
        setTimeout(() => {
            next()
        }, 250)
    },
})
export default class A extends Vue {
    hide = true
    categories = [
        'passionate',
        'forced',
        'undressing',
        'kissing',
        'cuddles',
        'cunnilingus',
        'fingering',
        'fucking',
        'anal',
        'choking',
        'bondage',
        ['girl', 'call her girl'],
        'text',
        'blowjob',
        ['fmasturbation', 'female masturbation'],
    ]
    selectedCategory: string[] = []

    created() {
        this.updateSelectedCategory()
    }
    mounted() {
        setTimeout(() => {
            this.hide = false
        }, 0)
    }

    updateSelectedCategory() {
        const category = this.$route.params.category
        // if (history.state?.scroll) {
        //     const scroll = history.state.scroll;
        //     setTimeout(() => {
        //         const container = this.$refs.container as HTMLDivElement;
        //         container.scrollTop = scroll;
        //         container.scrollTo({
        //             top: scroll,
        //             behavior: 'smooth'
        //         })
        //     }, 1000);
        // }

        if (!category) {
            this.selectedCategory = ['passionate', 'caress', 'undressing']
        } else {
            this.selectedCategory = [category]
            setTimeout(() => {
                const container = this.$refs.container as HTMLDivElement
                container.scrollTo({
                    top: window.innerHeight - 380,
                    behavior: 'smooth',
                })
            }, 0)
        }
    }

    getTitle(category?: string) {
        if (!category) {
            return 'Sexting GIFs'
        }
        const fullCategory = this.categories.find(
            cat => cat === category || cat[0] === category
        )
        const capitalize = (text: string) =>
            text.replace(/(^\w|\s\w)/g, (m: string) => m.toUpperCase())

        if (!fullCategory) {
            return 'ERROR'
        }
        if (Array.isArray(fullCategory)) {
            return capitalize(fullCategory[1])
        }
        return capitalize(fullCategory)
    }

    onScroll() {
        const container = this.$refs.container as HTMLDivElement
        // history.replaceState({
        //     scroll: container.scrollTop
        // }, '');
        if (
            container.scrollTop + container.offsetHeight + 100 >
            container.scrollHeight
        ) {
            const gifGrid = this.$refs.gifGrid as GifGrid
            gifGrid.loadMore()
        }
    }
}
